import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";
import "./WelcomeUAIC.css"; // Optional custom styles

import checkIcon from "../../assets/img/aboutus/check.svg";
import aboutBackground from "../../assets/img/aboutus/aboutBackground.svg";

const WelcomeUAIC = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div className="py-5" style={styles.container}>
        <Container style={{ maxWidth: "1350px", margin: "0 auto" }}>
          <Row
            className="align-items-center"
            style={{
              position: "relative",
              left: 0,
              marginLeft: "0px",
            }}
          >
            {/* Left Column: Text Content */}
            <Col lg={6}>
              <p
                style={{
                  color: "#17252E",
                  fontSize: "16px",
                  lineHeight: "140%",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  position: "relative", // required for ::after
                  display: "inline-block",
                }}
              >
                <span
                  style={{
                    position: "relative",
                    paddingBottom: "5px",
                  }}
                >
                  Our Mission
                  <span
                    style={{
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -4,
                      height: "1.6px",
                      width: "140%", // Extend beyond text
                      backgroundColor: "#0e72d6",
                      transform: "translateX(0%)", // Centered extension
                    }}
                  />
                </span>
              </p>

              <h2
                className="mt-2"
                style={{
                  color: "#17252E",
                  lineHeight: "1",
                  fontWeight: "bold",
                  fontSize: "40px",
                }}
              >
                Welcome to UAIC
              </h2>

              {/* <h5 className="text-primary mb-2"></h5> */}
              {/* <h1 className="fw-bold mb-4"></h1> */}
              <p className="mb-4 text-secondary">
                Our mission at United Automobile Insurance Company (UAIC) is to
                provide a quality, affordable, and reliable insurance product to
                a wide range sector of the American population. Through constant
                analysis and investments in technology and infrastructure, UAIC
                will continue to grow, while never losing sight of the
                underwriting discipline and claims philosophy that empowers our
                customer satisfaction.
              </p>

              <div className="d-flex flex-wrap gap-3">
                <ul
                  className={`${
                    responsiveStatus
                      ? "d-block flex-wrap gap-1"
                      : "d-flex flex-wrap gap-3"
                  }`}
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {[
                    "Industry Leadership",
                    "Service Excellence",
                    "Commitment to Growth",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: responsiveStatus ? "0px" : "12px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="aboutTextStyle">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Right Column: Image + Floating Cards */}
            <Col lg={6} className="position-relative mt-5 mt-lg-0 text-center ">
              {/* Circular Image */}
              <div className="uaic -image-wrapper mx-auto">
                <Image
                  src={require("../../assets/img/aboutus/img_uaic.svg")}
                  fluid
                  className="aboutRightImage"
                  alt="img_uaic"
                />
              </div>

              {/* Floating Cards */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${aboutBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default WelcomeUAIC;
